import api from "../../../services/apiClient"
import type { PermissionFormValues } from "../models/permission"

const BASE = "admin-permissions"

export const permissionApi = {
  getList: async () => {
    const { data } = await api.get(BASE)
    return data?.data ?? data
  },
  getByName: async (name: string) => {
    const { data } = await api.get(`${BASE}/${encodeURIComponent(name)}`)
    return data?.data ?? data
  },
  create: async (values: PermissionFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (name: string, values: Partial<PermissionFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${encodeURIComponent(name)}`, values)
    return data?.data ?? data
  },
  delete: async (name: string) => {
    const { data } = await api.delete(`${BASE}/delete/${encodeURIComponent(name)}`)
    return data
  },
}
